import firstSectionImage from "assets/images/homePage/firstSection.png"
import quotes from "assets/images/homePage/img_quotes.svg"
import React from "react"
import {
  flexBox,
  getMediaFor,
  MEDIA_BREAKPOINT_KEYS,
  responsiveImage,
} from "style/style_snippets"
import { Typography } from "@mui/material"

const HomeQuotation = ({ quotation }) => {
  const homeQuotationStyle = {
    container: {
      position: "relative",
      width: "45%",
      zIndex: 1,
      ...flexBox.row,
      justifyContent: "flex-end",
      alignItems: "flex-start",
    },

    coverImg: {
      ...responsiveImage,
      maxWidth: 490,
    },

    quotation: {
      position: "absolute",
      zIndex: -1,
      top: 255,
      left: -60,
      image: {
        ...responsiveImage,
        position: "absolute",
      },
      title: {
        ...getMediaFor("marginBottom", "8px", {
          [MEDIA_BREAKPOINT_KEYS.xs]: "12px",
          [MEDIA_BREAKPOINT_KEYS.sm]: "16px",
          [MEDIA_BREAKPOINT_KEYS.md]: "20px",
        }),
      },
      text: { width: "100%", padding: "110px 95px 0px 80px" },
    },
  }

  return (
    <div css={homeQuotationStyle.container}>
      <img css={homeQuotationStyle.coverImg} src={firstSectionImage} alt="" />
      <div css={homeQuotationStyle.quotation}>
        <img
          css={homeQuotationStyle.quotation.image}
          src={quotes}
          alt="quotes"
        />
        <div css={homeQuotationStyle.quotation.text}>
          <Typography variant={"h2"} css={homeQuotationStyle.quotation.title}>
            {quotation.title}
          </Typography>
          <Typography variant={"body1"}>{quotation.description}</Typography>
        </div>
      </div>
    </div>
  )
}

export default HomeQuotation
